import {
  activeDisplayTabOne,
  activeDisplayTabThree,
  activeDisplayTabTwo,
  displayTabOne,
  displayTabThree,
  displayTabTwo,
} from 'helper/helper';
import React, { useState } from 'react';

const AdPreview = ({ images }) => {
  const [activeTab, setActiveTab] = useState('mobile');
  const [desktopTab, setDesktopTab] = useState(1);

  const desktopSkeleton = (
    <span className='col-start-2 col-span-10 bg-gray-100 w-full h-16 rounded-lg' />
  );

  return (
    <>
      {/* tabs */}
      <div className='flex border-b justify-start bg-white'>
        <div
          onClick={() => setActiveTab('mobile')}
          className={`py-4 px-5 cursor-pointer ${
            activeTab === 'mobile'
              ? 'text-ezBlack border-b-2 border-ezGreen'
              : 'text-ezLightBlue border-b-2 border-transparent'
          }`}
        >
          Mobile View
        </div>
        <div
          onClick={() => setActiveTab('desktop')}
          className={`py-4 px-5 cursor-pointer ${
            activeTab === 'desktop'
              ? 'text-ezBlack border-b-2 border-ezGreen'
              : 'text-ezLightBlue border-b-2 border-transparent'
          }`}
        >
          Desktop View
        </div>
      </div>
      <div className='flex flex-col justify-start h-full'>
        {activeTab === 'mobile' && (
          <div className='grid grid-cols-10 place-items-center items-center h-full bg-gray-100 mb-28'>
            <div className='border rounded-lg col-start-4 col-span-4'>
              <div className='grid grid-cols-3 bg-gray-300 w-72 rounded-t-lg h-8 place-items-center'>
                <div className='col-start-2 w-24 h-5 bg-ezDarkGray rounded-b-xl mb-3' />
              </div>
              <div className='grid grid-cols-1 gap-4 card bg-white py-5 -px-2 w-72 place-items-center items-center rounded-b-lg'>
                <span className='bg-gray-100 w-60 h-24 rounded-lg' />
                <span className='bg-gray-100 w-60 h-24 rounded-lg' />
                {images[0]?.dataURL ? (
                  <div className='bg-white w-60 h-36 rounded-lg'>
                    <img
                      src={images[0]?.dataURL}
                      alt='Your Ad here.'
                      className='object-contain w-full h-full'
                    />
                  </div>
                ) : (
                  <div className='flex flex-col justify-center items-center bg-gray-200 w-60 h-24 rounded-lg'>
                    <p>Your ad here.</p>
                  </div>
                )}
                <span className='bg-gray-100 w-60 h-24 rounded-lg' />
              </div>
            </div>
          </div>
        )}
        {activeTab === 'desktop' && (
          <div className='mt-20 grid grid-cols-12 gap-y-6 place-items-center items-center h-2/3 bg-gray-100'>
            {desktopTab === 1 && (
              <div className='col-start-2 col-span-10 border w-full rounded-lg relative'>
                <div className='bg-gray-300 rounded-t-lg w-full h-8 place-items-center' />
                <div className='grid grid-cols-12 gap-2 card bg-white py-5 -px-2 place-items-center items-center rounded-b-lg relative'>
                  <div className='col-start-2 col-span-4 bg-gray-100 w-full h-96 rounded-lg' />
                  <span className='col-start-6 col-span-6 w-full'>
                    <div className='grid grid-cols-1 gap-2'>
                      <span className='bg-gray-100 w-full h-36 rounded-lg' />
                      <span className='bg-gray-100 w-full h-36 rounded-lg' />
                      <span className='bg-gray-100 w-full h-20 rounded-lg' />
                    </div>
                  </span>
                  {images[2]?.dataURL ? (
                    <div className='absolute bottom-0 w-3/4 rounded-lg'>
                      <img
                        src={images[2]?.dataURL}
                        alt='Your Ad here.'
                        className='object-contain w-full h-full'
                      />
                    </div>
                  ) : (
                    <div className='absolute bottom-0 bg-gray-200 w-2/3 h-16 rounded-t-lg'>
                      <p className='text-center mt-5'>Your ad here</p>
                    </div>
                  )}
                </div>
              </div>
            )}
            {desktopTab === 2 && (
              <div className='col-start-2 col-span-10 border w-full rounded-lg'>
                <div className='bg-gray-300 rounded-t-lg w-full h-8 place-items-center' />
                <div className='grid grid-cols-12 gap-4 card bg-white py-5 -px-2 place-items-center items-center rounded-b-lg'>
                  {desktopSkeleton}
                  {desktopSkeleton}
                  {desktopSkeleton}
                  {images[2]?.dataURL ? (
                    <div className='col-start-3 col-span-8 bg-white w-full h-16 rounded-lg'>
                      <img
                        src={images[2]?.dataURL}
                        alt='Your Ad here.'
                        className='object-contain w-full h-full'
                      />
                    </div>
                  ) : (
                    <div className='col-start-2 col-span-10 bg-gray-200 w-2/3 h-16 rounded-lg'>
                      <p className='text-center mt-5'>Your ad here</p>
                    </div>
                  )}
                  <span className='col-start-2 col-span-10 bg-gray-100 w-full h-16 rounded-lg' />
                </div>
              </div>
            )}
            {desktopTab === 3 && (
              <div className='col-start-2 col-span-10 border w-full rounded-lg'>
                <div className='bg-gray-300 rounded-t-lg w-full h-8 place-items-center' />
                <div className='flex flex-row card bg-white py-5 -px-2 place-items-center items-center rounded-b-lg'>
                  <div className='grid grid-cols-10 gap-4 w-full pr-5'>
                    {desktopSkeleton}
                    {desktopSkeleton}
                    {desktopSkeleton}
                    {desktopSkeleton}
                    {desktopSkeleton}
                  </div>
                  {images[2]?.dataURL ? (
                    <div className='bg-white w-28 h-full rounded-lg'>
                      <img
                        src={images[1]?.dataURL}
                        alt='Your Ad here.'
                        className='object-contain w-full h-full'
                      />
                    </div>
                  ) : (
                    <div className='flex flex-col items-center justify-center bg-gray-200 w-28 h-80 rounded-lg'>
                      <p className='text-center'>
                        Your <br /> ad <br /> here
                      </p>
                    </div>
                  )}
                </div>
              </div>
            )}
            <div className='col-start-5 col-span-4'>
              <div className='flex flex-row'>
                <div onClick={() => setDesktopTab(1)} className='p-1'>
                  {desktopTab === 1 ? activeDisplayTabOne : displayTabOne}
                </div>
                <div onClick={() => setDesktopTab(2)} className='p-1'>
                  {desktopTab === 2 ? activeDisplayTabTwo : displayTabTwo}
                </div>
                <div onClick={() => setDesktopTab(3)} className='p-1'>
                  {desktopTab === 3 ? activeDisplayTabThree : displayTabThree}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default AdPreview;
